//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class FileExtensionService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[FileExtension.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/file-extension/detail', {'params':params});
	};

	//GeneratorFlag:[FileExtension.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/file-extension/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}
